module.exports = __webpack_public_path__ + "img/159-cambodia.eb17c9be.svg";